import { ref as a, inject as c, nextTick as x, markRaw as h, unref as y } from "vue";
import { u as g } from "../uniqueId-fcX8zpZo.js";
import E from "../components/ToolTip.js";
const m = Symbol("popups"), d = Symbol("pushPopups"), f = Symbol("removePopups"), k = {
  install(n, {
    delay: s = 500,
    // ms
    mql: p
  } = {}) {
    if (!p)
      throw new Error("Missing MediaQueryListener instance");
    const i = a([]);
    n.provide(m, i);
    function l(e) {
      return e = v(e), i.value.push(e), {
        get visible() {
          return P(e.id);
        },
        pop: () => r(e.id)
      };
    }
    function v(e) {
      return e.id = g(), e.component = h(e.component), e.restoreFocusEl = document.activeElement, e.onClickOutside ??= (t) => {
        t.stopPropagation(), !y(e.ref).contains(t.target) && r(e.id);
      }, e.onEscape ??= (t) => {
        t.stopPropagation(), r(e.id);
      }, e.onWheelOutside ??= () => {
      }, e.parentClass ??= (t) => t, e.parentStyle ??= (t) => t, e;
    }
    function P(e) {
      return i.value.some((t) => t.id === e);
    }
    n.provide(d, l);
    function r(e) {
      const t = i.value.findIndex((w) => w.id === e);
      if (t === -1) return !1;
      const o = i.value[t];
      return i.value.splice(t, 1), o.focus && x(() => {
        o.restoreFocusEl?.focus();
      }), !0;
    }
    n.provide(f, r);
    const u = /* @__PURE__ */ new Map();
    n.directive("tooltip", {
      mounted(e, t) {
        const o = {
          popup: null,
          text: a(t.value)
        };
        e.addEventListener("mouseenter", () => {
          o.timeout = window.setTimeout(() => {
            !p.matches && !t.modifiers.mobile || o.text.value && (o.popup = l({
              component: E,
              ref: e,
              xClamp: !0,
              props: {
                text: o.text
              }
            }));
          }, s);
        }), e.addEventListener("mouseleave", () => {
          window.clearTimeout(o.timeout), o.popup?.pop();
        }), u.set(e, o);
      },
      updated(e, t) {
        const o = u.get(e);
        o && (o.text.value = t.value);
      },
      beforeUnmount(e) {
        const t = u.get(e);
        t && (window.clearTimeout(t.timeout), t.popup?.pop(), u.delete(e));
      }
    });
  }
};
function C() {
  return { popups: c(m) };
}
function K() {
  const n = c(d), s = c(f);
  return { pushPopup: n, removePopup: s };
}
export {
  k as PopupPlugin,
  m as popupsKey,
  d as pushPopupKey,
  f as removePopupKey,
  K as usePopupActions,
  C as usePopups
};
